import { useContext } from "react";
import { UserSettingsContext } from "../contexts/UserSettingsContext";

const useSettings = () => useContext(UserSettingsContext);

export default useSettings;
